import useQuoteStore from './store'
import {
  CompleteQuoteStepFn,
  CreateQuoteFn,
  DeleteQuoteFn,
  GetQuoteDataFn,
  GetQuoteStepDataFn,
  QuoteObject,
  UpdatedQuoteStepDataFn,
  UpdateQuoteGeneralInfoFn,
  UpdateQuoteStepFn,
} from './types'
import { FlowContext, useFlowContext } from 'directFlow/utils/FlowContext'

interface UseQuoteHandlerReturn {
  quotes: QuoteObject
  createQuote: CreateQuoteFn
  getQuoteData: GetQuoteDataFn
  getQuoteStepData: GetQuoteStepDataFn
  deleteQuote: DeleteQuoteFn
  completeQuoteStep: CompleteQuoteStepFn
  updateQuoteGeneralInfo: UpdateQuoteGeneralInfoFn
  updateQuoteStep: UpdateQuoteStepFn
  updateQuoteStepData: UpdatedQuoteStepDataFn
}

export const useQuoteHandler = (): UseQuoteHandlerReturn => {
  const store = useQuoteStore()

  const flowContext = useFlowContext()

  const isDirectQuote = flowContext === FlowContext.DIRECT

  if (isDirectQuote) {
    return {
      quotes: store.directQuotes,
      createQuote: store.createQuote,
      getQuoteData: store.getQuoteData,
      getQuoteStepData: store.getQuoteStepData,
      deleteQuote: store.deleteQuote,
      completeQuoteStep: store.completeQuoteStep,
      updateQuoteGeneralInfo: store.updateQuoteGeneralInfo,
      updateQuoteStep: store.updateQuoteStep,
      updateQuoteStepData: store.updateQuoteStepData,
    }
  }

  return {
    quotes: store.editQuotes,
    createQuote: store.createEditQuote,
    getQuoteData: store.getEditQuoteData,
    getQuoteStepData: store.getEditQuoteStepData,
    deleteQuote: store.deleteEditQuote,
    completeQuoteStep: store.completeEditQuoteStep,
    updateQuoteGeneralInfo: store.updateEditQuoteGeneralInfo,
    updateQuoteStep: store.updateEditQuoteStep,
    updateQuoteStepData: store.updateEditQuoteStepData,
  }
}
